// extracted by mini-css-extract-plugin
module.exports = {"lowStockLabel":"pk-z"};